import _isEmpty from 'lodash/isEmpty';
import updateDesign from './updateDesign';
import {
  selectToeKickSuperSkuId,
  selectProductsModalType,
  selectDesignById,
  selectProductsModalTypeByParentId
} from '../selectors';
import { getRecommendedToeKicks } from '../../../api';
import { getProductParentIdEntry } from './utils';

const getItemIdForColor = (colorLastAdded, toekickMetadata, previousId) => {
  const { childItemsLookup, defaultId } = toekickMetadata;
  return childItemsLookup?.find((item) => (
    item.attributeCombination?.includes(`${colorLastAdded}~~`)
  ))?.itemId ?? previousId ?? defaultId;
};

export default async (set, get, host, designId, updatedProducts,
  addedProductInfo, metadataBaseUrl, cabinetDirection) => {
  try {
    const stateCabinetVisualizer = get().cabinetVisualizer;
    const toeKickSuperSkuId = Number(selectToeKickSuperSkuId(stateCabinetVisualizer));
    const { Cart, ProductParentIds } = selectDesignById(stateCabinetVisualizer, designId);
    let updatedParents = getProductParentIdEntry(addedProductInfo?.itemId, addedProductInfo?.parentId);
    const newProductType = addedProductInfo?.newProductType
    || selectProductsModalTypeByParentId(stateCabinetVisualizer, addedProductInfo?.parentId, designId);

    let toeKickCount = 0;
    // Remove Existing toeKicks from cart
    const savedCart = Cart?.filter((nonVisProduct) => (
      Number(ProductParentIds[`${nonVisProduct.Sku}`]) !== toeKickSuperSkuId
    )) || [];
    const prevToeKick = Cart?.find((nonVisProduct) => (
      Number(ProductParentIds[`${nonVisProduct.Sku}`]) === toeKickSuperSkuId
    ));
    const baseCabinets = updatedProducts?.filter((product) => (
      product.productType === 'Base'
      || selectProductsModalType(stateCabinetVisualizer, product.Sku, designId) === 'Base'
    ));

    const baseCabinetAdded = newProductType === 'Base' && (addedProductInfo?.itemId > 0 || addedProductInfo?.Sku > 0);
    const cabinetDeleted = _isEmpty(addedProductInfo);
    const shouldCalculateToeKicks = !_isEmpty(baseCabinets)
    && (cabinetDeleted || baseCabinetAdded);

    // If we have baseCabinets in the new set (re-) calculate the toe kick #
    if (shouldCalculateToeKicks) {
      const prevToeKickId = prevToeKick?.Sku;
      const toeKickItemId = getItemIdForColor(
        addedProductInfo?.color,
        stateCabinetVisualizer.toeKickMetadata,
        prevToeKickId
      );
      toeKickCount = await getRecommendedToeKicks(host, baseCabinets, toeKickItemId);

      if (toeKickCount > 0) {
        updatedParents = {
          ...updatedParents,
          ...getProductParentIdEntry(toeKickItemId, toeKickSuperSkuId)
        };
        savedCart.push({
          Sku: toeKickItemId,
          Quantity: toeKickCount,
        });
      }
    } else if (prevToeKick && baseCabinets.length > 0) {
      savedCart.push(prevToeKick);
    }

    const updatedDesign = {
      Products: updatedProducts,
      Cart: savedCart,
      ProductParentIds: updatedParents
    };

    // Add anchorSide to updatedDesign if it exists
    if (cabinetDirection) {
      updatedDesign.AnchorSide = cabinetDirection;
    }

    set(
      updateDesign(set, get, host, designId, updatedDesign),
      false,
      { type: 'cabinetVisualizer/updateDesignProducts' }
    );
  } catch (err) {
    console.error(`Update Cabinet Design Error: ${err}`);
  }
};
